import { stateAbbreviations } from '@constants/stateAbbreviations'
import React, { useState } from 'react'

export const useStateSelect = () => {
  const [stateOptions, setStateOptions] = useState(stateAbbreviations)
  const onStateSearch = (value) => {
    const v = value.toLowerCase()
    setStateOptions(!value ? stateAbbreviations : stateAbbreviations.filter((x) => x.toLowerCase().includes(v)))
  }

  const renderItem = (index, title) => ({
    value: title,
    label: (
      <div
        key={index + title}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div className='bold-text'>{title}</div>
      </div>
    ),
    index,
  })

  const labeledStateOptions = [
    {
      label: <span>States</span>,
      options: stateOptions && stateOptions.map((state, i) => renderItem(i, state, ', ')),
    },
  ]

  return { labeledStateOptions, onStateSearch }
}
